import {
    MISSING_IDENTIFIER_ERROR_CODE, UNKNOWN_ERROR_CODE, AUTHENTICATION_REQUIRED_ERROR_CODE,
    ACCESS_DENIED_ERROR_CODE, NO_SOURCE_ID_ERROR_CODE, DATA_ACCESS_ERROR_CODE,
    LOGIN_FAILED_ERROR_CODE, INVALID_ITEM_EXCEPTION_CODE, INVALID_PASSWORD_EXCEPTION_CODE,
    CREATE_USER_EXCEPTION_CODE, USER_NOT_FOUND_EXCEPTION_CODE, ACCOUNT_LOCKED_ERROR_CODE,
    USERNAME_EXISTS_EXCEPTION_CODE, UNVALIDATED_ACCOUNT_ERROR
} from '../api/vsApi';
import { en, fr } from '../globals/strings_v3';
import { LANG_EN, LANG_FR } from './language_v3';

import ExtendedError from './extendedError'
import { lang } from 'moment';

export const ERROR_CONTEXT_LOGIN = "login";
export const ERROR_CONTEXT_LOGOUT = "logout";
export const ERROR_CONTEXT_REGISTER = "register";
export const ERROR_CONTEXT_RESULTS = "results";

// Get the error code and throw the right exception
export function handleErrors(error, lang, errorContext) {
    let message = "";
    let strings = en;
    // Not sure if this is possible, but just in case
    if (error == null) {
        throw new Error(strings.UNKNOWN_ERROR_MESSAGE);
    }
    // If there is no error, do nothing.
    if (error.error === false) {
        return;
    }
    if (lang === LANG_FR) {
        strings = fr;
    }
    if (error.code === MISSING_IDENTIFIER_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.MISSING_IDENTIFIER_MESSAGE, strings), error.code, error);
    } else if (error.code === AUTHENTICATION_REQUIRED_ERROR_CODE) {
        if (errorContext != null && errorContext === ERROR_CONTEXT_LOGOUT) {
            throw new ExtendedError(buildErrorMessage(error, strings.SESSION_TIMEOUT_ERROR, strings), error.code, error);
        } else {
            throw new ExtendedError(buildErrorMessage(error, strings.AUTHENTICATION_REQUIRED_MESSAGE, strings), error.code, error);
        }
    } else if (error.code === LOGIN_FAILED_ERROR_CODE && errorContext === ERROR_CONTEXT_LOGIN) {
        throw new ExtendedError(buildErrorMessage(error, strings.LOGIN_FAILED_MESSAGE, strings), error.code, error);
    } else if (error.code === INVALID_ITEM_EXCEPTION_CODE && errorContext === ERROR_CONTEXT_REGISTER) {
        throw new ExtendedError(buildErrorMessage(error, strings.REG_ERROR_INVALID_ITEM, strings), error.code, error);
    } else if (error.code === INVALID_PASSWORD_EXCEPTION_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.REG_ERROR_INVALID_PASSWORD, strings), error.code, error);
    } else if (error.code === CREATE_USER_EXCEPTION_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.REGISTER_FAILED_MESSAGE, strings), error.code, error);
    } else if (error.code === USER_NOT_FOUND_EXCEPTION_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.USER_NOT_FOUND_MESSAGE, strings), error.code, error);
    } else if (error.code === ACCESS_DENIED_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.ACCESS_DENIED_MESSAGE, strings), error.code, error);
    } else if (error.code === NO_SOURCE_ID_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.NO_ID_MESSAGE, strings), error.code, error);
    } else if (error.code === UNKNOWN_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE, strings), error.code, error);
    } else if (error.code === DATA_ACCESS_ERROR_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.DATA_ACCESS_MESSAGE, strings), error.code, error);
    } else if (error.code === ACCOUNT_LOCKED_ERROR_CODE) {
        throw new ExtendedError(createLockedOutMessage(strings), error.code, error);
    } else if (error.code === UNVALIDATED_ACCOUNT_ERROR) {
        throw new ExtendedError(createUnvalidatedMessage(strings, error.results), error.code, error, error.results);
    } else if (error.code === USERNAME_EXISTS_EXCEPTION_CODE) {
        throw new ExtendedError(buildErrorMessage(error, strings.USUERNAME_EXISTS_ERROR_MESSAGE, strings), error.code, error);
    }
    else {
        // FIXME Differentiate this from previous state?
        throw new ExtendedError(buildErrorMessage(error, strings.UNKNOWN_ERROR_MESSAGE, strings), error.code, error);
    }
}

function createLockedOutMessage(strings){
    return strings.ALO_PASS_RESET_MESSAGE_1+strings.FORGOT_UN_LINK+strings.ALO_PASS_RESET_MESSAGE_2+strings.FORGOT_PASS_LINK;
}

function createUnvalidatedMessage(str, results){
    return str.UNVALIDATED_ERROR_MESSAGE_1+str.UNVALIDATED_ERROR_MESSAGE_2+str.UNVALIDATED_ERROR_MESSAGE_3+" "+results+str.UNVALIDATED_ERROR_MESSAGE_4+str.UNVALIDATED_ERROR_MESSAGE_5
}

function buildErrorMessage(error, message, strings) {
    let id = "";
    if (error.id != null) {
        id = error.id;
    }
    return message + " (" + error.code + " - " + error.statusCode + " - " + id + ")";
}

export function createError(code, statusCode, id) {
    return { error: true, code: code, id: id, statusCode: statusCode }
}

export function createUnvalidatedAccountError(code, statusCode, id, results) {
    return { error: true, code: code, id: id, statusCode: statusCode, results: results }
}